export const getCurrencyCookie = (name: string) => {
  const cookies = typeof window !== 'undefined' ? document?.cookie.split('; ') : [];
  const targetCookie = cookies?.find((cookie) => cookie?.startsWith(name + '='));
  if (!targetCookie) return null;
  return JSON.parse(decodeURIComponent(targetCookie.split('=')[1]));
};
